import { colorFields, productFragment } from "./fragments";

export const product = `
  query product($id: ID!, $buyer: BuyerInput) @inContext(country: ${window.Shopify.country}, buyer: $buyer) {
    product(id: $id) {
      ${productFragment}
    }
  }
`;

export const productByHandle = `
  query product($handle: String!, $buyer: BuyerInput) @inContext(country: ${window.Shopify.country}, buyer: $buyer) {
    product(handle: $handle) {
      ${productFragment}
    }
  }
`;

const mediaImageReference = `
reference {
  ... on MediaImage {
    id
    image {
      altText
      url
      width
      height
    }
  }
}
`;

export const monogramComponentByHandle = `
  query monogramComponentByHandle($handle: MetaobjectHandleInput!, $buyer: BuyerInput) @inContext(country: ${window.Shopify.country}, buyer: $buyer) {
    metaobject(handle: $handle) {
      id
      handle
      type
      key: field(key: "key") { value }
      name: field(key: "name") { value }
      enableProductDetail: field(key: "enable_product_detail") { value }
      monogramTypes: field(key: "monogram_types") { value }
      monogramStyles: field(key: "monogram_styles") {
        references(first: 100) {
          nodes {
            ... on Metaobject {
              id
              handle
              type
              key: field(key: "key") { value }
              styleName: field(key: "style_name") { value }
              monogramTypes: field(key: "monogram_types") { value }
              styleImage: field(key: "style_image") { ${mediaImageReference} }
              border: field(key: "border") { ${mediaImageReference} }
              borderAppliesTo: field(key: "border_applies_to") { value }
              pricingClass: field(key: "pricing_class") { value }
              disclaimer: field(key: "disclaimer") { value }
              letters: field(key: "letters") {
                references(first: 100) {
                  nodes {
                    ... on Metaobject {
                      id
                      handle
                      type
                      key: field(key: "key") { value }
                      letter: field(key: "letter") { value }
                      leftPosition: field(key: "left_position") { ${mediaImageReference} }
                      centerPosition: field(key: "center_position") { ${mediaImageReference} }
                      rightPosition: field(key: "right_position") { ${mediaImageReference} }
                      twoLetterLeftPosition: field(key: "2_letter_left_position") { ${mediaImageReference} }
                      twoLetterRightPosition: field(key: "2_letter_right_position") { ${mediaImageReference} }
                    }
                  }
                }
              }
              text: field(key: "text") {
                references(first: 5) {
                  nodes {
                    ... on Metaobject {
                      id
                      handle
                      type
                      key: field(key: "key") { value }
                      font: field(key: "font") {
                        reference {
                          ... on GenericFile {
                            id
                            url
                          }
                        }
                      }
                      size: field(key: "size") { value }
                      lineHeight: field(key: "line_height") { value }
                      letterSpacing: field(key: "letter_spacing") { value }
                      uppercase: field(key: "uppercase") { value }
                      lettersOnly: field(key: "letters_only") { value }
                    }
                  }
                }
              }
            }
          }
        }
      }
      monogramPlacement: field(key: "monogram_placement") {
        references(first: 100) {
          nodes {
            ... on Metaobject {
              id
              handle
              type
              key: field(key: "key") { value }
              size: field(key: "size") { value }
              pricingHeight: field(key: "pricing_height") { value }
              position: field(key: "position") { value }
              image: field(key: "image") { ${mediaImageReference} }
              productDetailTop: field(key: "product_detail_top") { value }
              productDetailLeft: field(key: "product_detail_left") { value }
              productDetailScale: field(key: "product_detail_scale") { value }
              extendedLeadTime: field(key: "extended_lead_time") { value }
              leadTimeOverride: field(key: "lead_time_override") { value }
            }
          }
        }
      }
      monogramProduct: field(key: "monogram_product") {
        reference {
          ... on Product {
            ${productFragment}
          }
        }
      }
    }
    monogramColors: metaobject(handle: { handle: "global", type: "monogram_colors" }) {
      id
      colors: field(key: "colors") {
        references(first: 100) {
          nodes {
            ... on Metaobject {
              ${colorFields}
            }
          }
        }
      }
    }
  }
`;

export const pressListings = `
  query pressListings($first: Int!, $after: String) {
    metaobjects(type: "press", first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        handle
        publication: field(key: "publication") { value }
        pressTitle: field(key: "title") { value }
        date: field(key: "date") { value }
        dateLabel: field(key: "date_label") { value }
        featured: field(key: "featured") { value }
        image: field(key: "image") { ${mediaImageReference} }
        pdf: field(key: "pdf") {
          reference {
            ... on GenericFile {
              url
            }
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
      }
    }
  }
`;
